import React, { Component } from 'react';
import { TextField, Button, CircularProgress } from '@material-ui/core/';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import AppState from '../../state';
import img_logo from '../../assets/images/logo_lazarus.png';

import '../login/style.css';

// Tela do link de "esqueci minha senha".
// Chega por e-mail no formato /redefinir-senha?u=<cpf>&t=<token>.
// Nao exige login: quem autoriza e' o token, conferido pelo servidor.
class RedefinirSenha extends Component {
  state = {
    novaSenha: '',
    repetirSenha: '',
    erro: '',
    concluido: false,
    enviando: false,
  };

  _dadosDoLink = () => {
    const busca =
      this.props.location && this.props.location.query
        ? this.props.location.query
        : {};
    return { cpf: busca.u || '', token: busca.t || '' };
  };

  _handleChange = (campo) => (event) => {
    this.setState({ [campo]: event.target.value, erro: '' });
  };

  _handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      this._enviar();
    }
  };

  _enviar = () => {
    const { novaSenha, repetirSenha } = this.state;
    const { cpf, token } = this._dadosDoLink();

    if (!cpf || !token) {
      this.setState({
        erro: 'Este link está incompleto. Abra o link direto do e-mail que você recebeu.',
      });
      return;
    }
    if (novaSenha.length < 6 || novaSenha.length > 72) {
      this.setState({ erro: 'A senha deve ter de 6 a 72 caracteres.' });
      return;
    }
    if (novaSenha !== repetirSenha) {
      this.setState({ erro: 'As duas senhas digitadas não são iguais.' });
      return;
    }

    this.setState({ enviando: true, erro: '' });

    fetch(`${AppState.serverAddr}/comum/ResetPwD.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify({ cpf: cpf, token: token, newpwd: novaSenha }),
    })
      .then((resposta) =>
        resposta.json().then((corpo) => ({ ok: resposta.ok, corpo: corpo }))
      )
      .then(({ ok, corpo }) => {
        this.setState({ enviando: false });

        if (ok) {
          this.setState({ concluido: true });
          return;
        }

        const codigo = ((corpo.status || {}).value || '').split(' ')[0];
        if (codigo === '40103') {
          this.setState({
            erro:
              'Este link já passou da validade (1 hora). Volte ao login e peça "Esqueci minha senha" de novo.',
          });
        } else if (codigo === '40101') {
          this.setState({
            erro:
              'Este link não vale mais. Ele só pode ser usado uma vez — se você já trocou a senha, é só entrar com ela.',
          });
        } else if (codigo === '40102') {
          this.setState({ erro: 'Este usuário está bloqueado. Procure o setor de TI.' });
        } else if (codigo === '40003') {
          this.setState({ erro: 'A senha deve ter de 6 a 72 caracteres.' });
        } else {
          this.setState({ erro: 'Não foi possível trocar a senha agora. Tente de novo em alguns minutos.' });
        }
      })
      .catch(() => {
        this.setState({
          enviando: false,
          erro: 'Não foi possível falar com o sistema. Verifique sua internet e tente de novo.',
        });
      });
  };

  render() {
    const { concluido, erro, enviando } = this.state;

    return (
      <div id="Login" className="login-place">
        <div className="logo-header">
          <img className="logo-img" src={img_logo} alt="Lazarus" />
        </div>
        <div className="right-content">
          <div>
            <div className="box-login">
              {AppState.isDevMode && <p>Ambiente de testes</p>}

              {concluido ? (
                <div>
                  <h3 style={{ marginBottom: 8 }}>Senha cadastrada</h3>
                  <p style={{ fontSize: '0.9rem', lineHeight: 1.5 }}>
                    Pronto. Já pode entrar no sistema com a sua senha nova.
                  </p>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() =>
                      browserHistory.push(`${process.env.PUBLIC_URL}/login`)
                    }
                  >
                    Ir para o login
                  </Button>
                </div>
              ) : (
                <div>
                  <h3 style={{ marginBottom: 8 }}>Cadastrar senha nova</h3>
                  <p style={{ fontSize: '0.85rem', lineHeight: 1.5, marginBottom: 16 }}>
                    Escolha uma senha de <strong>6 a 24 caracteres</strong>. Pode
                    misturar letras, números e símbolos — e ela diferencia
                    maiúsculas de minúsculas.
                  </p>

                  <TextField
                    id="novaSenha"
                    label="NOVA SENHA"
                    type="password"
                    fullWidth
                    inputProps={{ maxLength: 72 }}
                    value={this.state.novaSenha}
                    onChange={this._handleChange('novaSenha')}
                    onKeyUp={this._handleKeyUp}
                  />
                  <TextField
                    id="repetirSenha"
                    label="REPITA A SENHA"
                    type="password"
                    fullWidth
                    inputProps={{ maxLength: 72 }}
                    value={this.state.repetirSenha}
                    onChange={this._handleChange('repetirSenha')}
                    onKeyUp={this._handleKeyUp}
                  />

                  {erro !== '' && (
                    <p style={{ color: '#c0392b', fontSize: '0.85rem', lineHeight: 1.5, marginTop: 12 }}>
                      {erro}
                    </p>
                  )}

                  <Button
                    variant="contained"
                    fullWidth
                    disabled={enviando}
                    onClick={this._enviar}
                    style={{ marginTop: 16 }}
                  >
                    {enviando ? <CircularProgress size={22} /> : 'Salvar senha'}
                  </Button>

                  <Button
                    style={{ marginTop: 12 }}
                    fullWidth
                    onClick={() =>
                      browserHistory.push(`${process.env.PUBLIC_URL}/login`)
                    }
                  >
                    Voltar para o login
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(RedefinirSenha);
